import {ErrorBox} from '@/components/commons/error-box/ErrorBox'
import {FormSectionLoader} from '@/components/commons/form-section/FormSectionLoader'
import {Divider} from '@/components/ui/divider/Divider'
import {AlertCircleIcon} from '@/components/ui/icon/Icon'
import {PageCardWrapper} from '@/components/ui/page-atoms/PageAtoms'
import {Text} from '@/components/ui/text/Text'
import {EditPlannedAccessesFormCard} from '@/features/planned-accesses/components/accesses-form/edit-planned-accesses-form-card/EditPlannedAccessesFormCard'
import {EditPlannedAccessesFormProvider} from '@/features/planned-accesses/components/accesses-form/edit-planned-accesses-form-provider/EditPlannedAccessesFormProvider'
import {useGetPlannedAccesses} from '@/features/planned-accesses/queries/useGetPlannedAccesses'
import {PlannedAccessUrlParams} from '@/features/planned-accesses/types'
import {ProjectFormHeadingLoader} from '@/features/projects/components/project-form/project-form-heading/ProjectFormHeadingLoader'
import {useGetProject} from '@/features/projects/queries/useGetProject'
import {useURLParsedParams} from '@/hooks/useURLParsedParams'
import {useTranslation} from '@/translations/i18n'
import {raise} from '@/utilities/helpers'
import {Helmet} from 'react-helmet'
import {usePermissions} from '@/features/auth/store/store'
import {NoPermissionBox} from '@/components/commons/no-permission-box/NoPermissionBox'

export const EditPlannedAccesses = () => {
    const {t} = useTranslation()
    const permissions = usePermissions()
    const urlParams = useURLParsedParams(PlannedAccessUrlParams)

    const {
        data: project,
        isLoading: isLoadingProject,
        isError: isErrorProject
    } = useGetProject({
        urlParams: {projectId: urlParams.success ? urlParams.data.id : ''},
        params: {responseType: 'extended'},
        options: {enabled: urlParams.success}
    })

    const {
        data: plannedAccesses,
        isLoading: isLoadingPlannedAccesses,
        isError: isErrorPlannedAccesses
    } = useGetPlannedAccesses({
        urlParams: {
            projectId: urlParams.success ? urlParams.data.id : raise('Project ID is required')
        },
        options: {
            enabled: urlParams.success
        }
    })

    if (!permissions?.projects.read) {
        return <NoPermissionBox />
    }

    return (
        <>
            <Helmet title={t('planned_accesses:edit_meta_title')} />
            {isLoadingPlannedAccesses || isLoadingProject ? (
                <PageCardWrapper>
                    <ProjectFormHeadingLoader />
                    <Divider direction="horizontal" />
                    <FormSectionLoader />
                </PageCardWrapper>
            ) : isErrorPlannedAccesses || isErrorProject ? (
                <ErrorBox icon={<AlertCircleIcon />} title={t('errors:default')} />
            ) : plannedAccesses ? (
                <EditPlannedAccessesFormProvider
                    defaultValues={plannedAccesses}
                    isMixedProject={project?.sector === 'mixed'}
                >
                    <EditPlannedAccessesFormCard />
                </EditPlannedAccessesFormProvider>
            ) : (
                <Text size="textSm" palette="neutral" shade="700">
                    {t('commons:no_results')}
                </Text>
            )}
        </>
    )
}
